if (!customElements.get('faq-tabs-section')) {
  customElements.define(
    'faq-tabs-section',
    class FaqTabsSection extends HTMLElement {
      constructor() {
        super();
        this.tabButtons = Array.from(this.querySelectorAll('[data-tab-target]'));
        this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
        this.activeTab = this.dataset.defaultTab || this.tabButtons[0]?.dataset.tabTarget;
      }

      connectedCallback() {
        if (!this.tabButtons.length || !this.panels.length) return;

        this.tabButtons.forEach((button, index) => {
          button.addEventListener('click', () => this.activateTab(button.dataset.tabTarget));
          button.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        this.activateTab(this.activeTab);
      }

      onKeydown(event, currentIndex) {
        const key = event.key;
        const lastIndex = this.tabButtons.length - 1;
        let nextIndex = null;

        if (key === 'ArrowRight') nextIndex = currentIndex === lastIndex ? 0 : currentIndex + 1;
        if (key === 'ArrowLeft') nextIndex = currentIndex === 0 ? lastIndex : currentIndex - 1;
        if (key === 'Home') nextIndex = 0;
        if (key === 'End') nextIndex = lastIndex;

        if (nextIndex === null) return;

        event.preventDefault();
        const nextButton = this.tabButtons[nextIndex];

        if (!nextButton) return;

        nextButton.focus();
        this.activateTab(nextButton.dataset.tabTarget);
      }

      activateTab(target) {
        if (!target) return;

        this.activeTab = target;

        this.tabButtons.forEach((button) => {
          const isActive = button.dataset.tabTarget === target;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
          button.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.panels.forEach((panel) => {
          const isActive = panel.dataset.tabPanel === target;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      }
    }
  );
}
